var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64969 7.8H5.46969L11.1497 2.12L10.4397 1.41L11.8597 0L18.9297 7.07L17.5097 8.48L16.7997 7.77L11.1297 13.45H11.1397V16.28L9.71969 17.7L6.17969 14.15L1.40969 18.92L-0.000312805 17.51L4.76969 12.74L1.23969 9.21L2.64969 7.8Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin_icon.43323c923285010d66f90d4203c3fcd3.svg";
export { ForwardRef as ReactComponent };